module.exports = __webpack_public_path__ + "static/img/8_10commitments_50millions.e270b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/8_10commitments_50millions.jpg
// module id = njba
// module chunks = 0